<div class="modal-header">
  <h5 class="modal-title text-center ml-auto mr-auto">{{ 'select_last_season_rank' | translate: lang }}</h5>
  <button (click)="modalService.closeOutletModals('public')" type="button" class="close" data-dismiss="modal" aria-label="Close">
    <svg-selector [svgName]="'close-small'" [svgColor]="'#ffffff'"></svg-selector>
  </button>
</div>
<div class="modal-body">

  <div class="row">

    <div class="col-md text-center rank-select-item" (click)="onSelect(0)">
      <img height="120" src="{{'https://cdn.ggboost.com/images/apex-ranks/unranked.webp' | cdn}}" alt="">
      <div>Unranked</div>
    </div>

    <div class="col-md text-center rank-select-item" (click)="onSelect(1)">
      <img height="120" src="{{'https://cdn.ggboost.com/images/apex-ranks/rookie.webp' | cdn}}" alt="">
      <div>Rookie</div>
    </div>

    <div class="col-md text-center rank-select-item" (click)="onSelect(5)">
      <img height="120" src="{{'https://cdn.ggboost.com/images/apex-ranks/bronze.webp' | cdn}}" alt="">
      <div>Bronze</div>
    </div>

    <div class="col-md text-center rank-select-item" (click)="onSelect(9)">
      <img height="120" src="{{'https://cdn.ggboost.com/images/apex-ranks/silver.webp' | cdn}}" alt="">
      <div>Silver</div>
    </div>

    <div class="col-md text-center rank-select-item" (click)="onSelect(13)">
      <img height="120" src="{{'https://cdn.ggboost.com/images/apex-ranks/gold.webp' | cdn}}" alt="">
      <div>Gold</div>
    </div>

    <div class="col-md text-center rank-select-item" (click)="onSelect(17)">
      <img height="120" src="{{'https://cdn.ggboost.com/images/apex-ranks/platinum.webp' | cdn}}" alt="">
      <div>Platinum</div>
    </div>

    <div class="col-md text-center rank-select-item" (click)="onSelect(21)">
      <img height="120" src="{{'https://cdn.ggboost.com/images/apex-ranks/diamond.webp' | cdn}}" alt="">
      <div>Diamond</div>
    </div>

    <div class="col-md text-center rank-select-item" (click)="onSelect(25)">
      <img height="120" src="{{'https://cdn.ggboost.com/images/apex-ranks/master.webp' | cdn}}" alt="">
      <div>Master</div>
    </div>

    <div class="col-md text-center rank-select-item" (click)="onSelect(26)">
      <img height="120" src="{{'https://cdn.ggboost.com/images/apex-ranks/predator.webp' | cdn}}" alt="">
      <div>Predator</div>
    </div>
  </div>

</div>
